import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import s from './App.scss';
import {
  notifyViewFinishedLoading,
  isAppInstalled,
  provisionApp,
  appDefIds,
  getCurrentInstance,
  refreshInstance,
} from '@wix/business-manager-api';
import { create } from '@wix/fedops-logger';

import { COMPONENT_NAME } from '../../config';
import CorvidPage from '../CorvidPage';

function getUrlParameter(name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const results = regex.exec(location.search);
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
class App extends React.Component {
  static propTypes = {
    t: PropTypes.func,
    config: PropTypes.object.isRequired,
    localeFile: PropTypes.string.isRequired,
    wixOnWixUrl: PropTypes.string.isRequired,
    biLogger: PropTypes.func.isRequired,
    metaSiteId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      width: undefined,
      height: undefined,
      url: undefined,
    };
  }
  async setUrl() {
    const instance =
      getCurrentInstance(appDefIds.secretsVault) ||
      (await refreshInstance(appDefIds.secretsVault));

    const { locale, localeFile, wixOnWixUrl, userRole } = this.props.config;
    const siteRevision = getUrlParameter('siteRevision') || '0';

    const url = `${
      wixOnWixUrl ||
      'https://www.wix.com/secretsmanager/key-manager/key-manager'
    }?siteRevision=${siteRevision}&localeFile=${encodeURIComponent(
      localeFile,
    )}&userRole=${userRole}&locale=${locale}&instance=${instance}&siteRevision=${siteRevision}`;
    this.setState({ url });
  }

  updateDimensions() {
    if (this.rootElem) {
      const { width, height } = this.rootElem.getBoundingClientRect();
      this.setState({
        width,
        height,
      });
    }
  }
  getInstanceAndSetUrl() {
    const { metaSiteId } = this.props.config;
    const isSecretsVaultAppInstalled = isAppInstalled(appDefIds.secretsVault);
    isSecretsVaultAppInstalled
      ? this.setUrl()
      : provisionApp(appDefIds.secretsVault, metaSiteId).then(() => {
          this.setUrl();
        });
  }
  componentDidMount() {
    // Note: you might want to invoke notify after initial data fetch (to keep BM loader during fetch)
    this.getInstanceAndSetUrl();
    const fedopsLogger = create(COMPONENT_NAME);
    fedopsLogger.appLoaded();
    notifyViewFinishedLoading(COMPONENT_NAME);
    window.addEventListener('resize', this.updateDimensions.bind(this));
    this.updateDimensions();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions.bind(this));
  }

  canRenderCorvidPage() {
    return this.state.width !== undefined && this.state.url !== undefined;
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { t, biLogger } = this.props;
    return (
      <div className={s.root} ref={(e) => (this.rootElem = e)}>
        {this.canRenderCorvidPage() ? (
          <CorvidPage
            url={this.state.url}
            width={this.state.width}
            height={this.state.height}
            biLogger={biLogger}
          />
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default translate(null, { wait: true })(App);
